import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Banner } from 'src/app/models/banner.model';
import { BannersService } from 'src/app/services/banners.service';
import { Router } from '@angular/router';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-banners',
  templateUrl: './banners.component.html',
  styleUrls: ['./banners.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class BannersComponent implements OnInit {

   banners: Banner[] = [];
   idCardSelected: number = 1;

  constructor(
    private bannersService: BannersService,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
     this.bannersService.getBanners(this.idCardSelected)
     .subscribe(
       (banners: Banner[]) => {
          this.banners = banners;
          this.bannersService.setBanners(banners);
       }
     );
  }

 getMobileFormat(bannerName : string){

  return bannerName.replace('promo-name', 'promo-name-mobile');

 }

}
